import React from "react";
import { FaServer, FaCloud, FaShield } from "react-icons/fa6";
import banner12 from "../assets/banner12.jpg";

export default function WebHosting() {
  const features = [
    { icon: <FaServer size={20} className="text-primary" />, text: "Shared, VPS, and dedicated hosting solutions tailored to your needs." },
    { icon: <FaCloud size={20} className="text-primary" />, text: "Domain management, SSL integration, and scalable infrastructure." },
    { icon: <FaShield size={20} className="text-primary" />, text: "Reliable uptime monitoring and secure server environments." },
  ];

  return (
    <section className="MainBodySection service-detail-page">
      <div className="container service-detail-shell">
        <div className="text-center">
          <div className="section-kicker mb-3">Service Detail</div>
          <h2 className="main-section-title">Web Hosting Services</h2>
          <p className="section-copy">
            Provision of reliable and scalable hosting solutions including shared hosting, VPS, and dedicated servers with domain management, SSL integration, and uptime monitoring.
          </p>
        </div>

        <div className="service-detail-media">
          <img src={banner12} alt="Web Hosting Services" />
        </div>

        <div className="detail-card">
          <p className="detail-summary mb-4">
            Provide organizations with reliable web hosting environments that support website performance, security, and growth.
          </p>

          <ul className="detail-feature-list mb-4">
            {features.map(item => (
              <li key={item.text} className="detail-feature-item">{item.icon}<span>{item.text}</span></li>
            ))}
          </ul>

          <ol className="detail-step-list">
            <li>Evaluate hosting needs based on website and application requirements.</li>
            <li>Configure servers, domains, and SSL certificates for security and accessibility.</li>
            <li>Deploy monitoring tools for uptime and performance tracking.</li>
            <li>Provide maintenance, backups, and scaling as needed.</li>
          </ol>
        </div>
      </div>
    </section>
  );
}